import React, { useState, useRef } from 'react';
import { Calendar } from 'primereact/calendar';
import {
    DatePickerContainer,
    DatePickerDiv,
    DatePickerIcon,
    StyledClearSpan,
    StyledDiv,
    StyledSpan,
    DatePopover,
} from './DatePicker.styled';
import { Dropdown } from 'primereact/dropdown';
import CalendarInactive from 'src/assets/images/Menu/Calendar_Inactive.svg';
import { getDisplayDate } from 'src/utils/dateUtils';
import { useTranslation } from 'react-i18next';
import LeftArrow from 'src/assets/images/BaselineKeyboardArrowLeft24.svg';
import RightArrow from 'src/assets/images/BaselineKeyboardArrowRight24.svg';
import DownArrowMonthDropDown from 'src/assets/images/DownArrowMonthDropDown.svg';
import { useEffectWithErrorLogging } from 'src/utils/useEffectWithErrorLogging';
import { logErrorToConsole } from 'src/utils/util';

const DatePicker = ({
    datepickerItem,
    placeholder,
    disableWeekEnds,
    enableMinDate = '',
    onChange,
    selectedDateFromDatePicker,
    datePickerCalendarIcon,
    datePickerDivWidth,
    borderRadius,
    datePickerDivHeight,
    minDate,
    sameDayRdd,
    maxDate,
    datePickerDivMbWidth,
    datePickerDivMbHeight,
    iconHeight,
    fontSize,
    disabled,
    left,
    opacity,
    datePickerBgColor,
    border,
    datePopOverZIndex,
    // sameDayRdd,
    // mobileHeight,
    yearRange,
    iconPaddingTop,
    iconRight,
    reportUsage,
    textOpacity,
    smbWidth,
    smbIconPaddingTop,
    smbIconheight,
    rdd,
    mbIconRight,
    minWidth,
    id
}) => {
    // const datePopoverRef = useRef();
    const monthDDRef = useRef();
    const yearDDRef = useRef();
    const { t } = useTranslation();
    const [topY, setTopY] = useState();
    const [dateSelectorPopUpAnchorEl, setDateSelectorPopUpAnchorEl] =
        React.useState(null);
    const [disablePrevMonth, setDisablePrevMonth] = useState(false);
    const [selectedYear, setSelecterYear] = useState(0);
    const monthNames = [
        { name: 'January', id: 0 },
        { name: 'February', id: 1 },
        { name: 'March', id: 2 },
        { name: 'April', id: 3 },
        { name: 'May', id: 4 },
        { name: 'June', id: 5 },
        { name: 'July', id: 6 },
        { name: 'August', id: 7 },
        { name: 'September', id: 8 },
        { name: 'October', id: 9 },
        { name: 'November', id: 10 },
        { name: 'December', id: 11 },
    ];

    const dateSelectorPopUpOpen = (event) => {
        setTopY(event.clientY);
        // const testTop = window.innerHeight - event.clientY;
        if (!disabled) setDateSelectorPopUpAnchorEl(event.currentTarget);

        // Enable/disbale the next button on initial load
        toggleNextButton();
    };

    // Enable/disbale the next button
    const disableNextButton = () => {
        const nextButton = document.getElementsByClassName(
            'p-datepicker-next p-link'
        )[0];
        nextButton?.addEventListener('click', (e) => {
            e.stopPropagation();
            e.preventDefault();
        });
    };

    const toggleNextButton = () => {
        if (!maxDate) return;
        setTimeout(() => {
            try {
            var viewMonth = monthDDRef.current.input.innerText.split('\n')[0];
            var viewYear = yearDDRef.current.input.innerText.split('\n')[0];
            if (
                viewYear >= maxDate.getFullYear() &&
                monthNames.find((item) => item.name === viewMonth).id ===
                    maxDate.getMonth()
            ) {
                disableNextButton();
            }
            } catch (error) {
                logErrorToConsole(error);
            }
        }, 100);
    };

    const dateSelectorPopUpClose = () => {
        setDateSelectorPopUpAnchorEl(null);
    };
    const isDateSelectorPopOverOpen = Boolean(dateSelectorPopUpAnchorEl);
    const dateSelectorPopOverId = isDateSelectorPopOverOpen
        ? 'simple-popover'
        : undefined;
    var getmonths;

    const calendarRef = useRef();

    const hasSelectedDate =
        selectedDateFromDatePicker !== null &&
        selectedDateFromDatePicker !== undefined &&
        selectedDateFromDatePicker !== '' &&
        selectedDateFromDatePicker !== 0 &&
        !(
            selectedDateFromDatePicker instanceof Date &&
            selectedDateFromDatePicker.getTime &&
            selectedDateFromDatePicker.getTime() === 0
        );

    const calendarPopoverClickHandler = (e) => {
        if (
            calendarRef &&
            calendarRef.current &&
            calendarRef.current.contains(e.target)
        ) {
            // do not close calendar when clicked anywhere inside popover or
            // when dropdown element from month or year dropdown is selected
            return;
        }
        // if clicked outside popover-
        dateSelectorPopUpClose();
    };

    useEffectWithErrorLogging(() => {
        document.addEventListener('mousedown', calendarPopoverClickHandler);
        document.addEventListener('touchstart', calendarPopoverClickHandler); // Add this
        return () => {
            document.removeEventListener('mousedown', calendarPopoverClickHandler);
            document.removeEventListener('touchstart', calendarPopoverClickHandler); // And this
        };
    }, []);

    const clearSelectedDate = () => {
        onChange(null);
    };
    const monthNavigatorTemplate = (e) => {
        let selectedMonth = e.value;
        if (selectedMonth !== '' && rdd) {
            const currentMonth = new Date().getMonth();
            const currentYear = new Date().getFullYear();
            const selectedMonthName = monthNames
                .find((item) => item.id === selectedMonth)
                .name.toLowerCase();
            const currentMonthName = monthNames
                .find((item) => item.id === currentMonth)
                .name.toLowerCase();

            if (
                (selectedMonthName.includes('january') &&
                    selectedYear === currentYear) ||
                (selectedMonthName?.includes(currentMonthName) &&
                    selectedYear === currentYear)
            ) {
                setDisablePrevMonth(true);
            } else {
                setDisablePrevMonth(false);
            }
        }

        getmonths = e.options;

        let startedmonth = monthNames.filter(
            (currentvalue) => currentvalue.name === e.names[0]
        );
        let count = startedmonth[0].id - 1;
        for (var i = 0; i < getmonths.length; i++) {
            count += 1;
            getmonths[i].value = count;
            getmonths[i].index = count;
        }

        return (
            <span>
                <Dropdown
                    onChange={(event) => {
                        e.onChange(event.originalEvent, event.value);
                    }}
                    value={e.value}
                    options={e.options}
                    style={dropdownstyle}
                    appendTo={'self'}
                    id="monthDD"
                    ref={monthDDRef}
                />
            </span>
        );
    };

    const yearNavigatorTemplate = (e) => {
        setSelecterYear(e.value);
        return (
            <span>
                <Dropdown
                    value={e.value}
                    options={e.options}
                    onChange={(event) => {
                        e.onChange(event.originalEvent, event.value);
                    }}
                    id="yearDD"
                    appendTo={'self'}
                    style={{ lineHeight: 1 }}
                    ref={yearDDRef}
                />
                <StyledClearSpan onClick={clearSelectedDate}>
                    {t('common.clearButton')}
                </StyledClearSpan>
            </span>
        );
    };

    const dropdownstyle = {
        width: '10px !important',
        lineHeight: 1,
    };

    // const headerTemplate = () => {
    //     return <div>Clear</div>;
    // };
    return (
        <>
            <DatePickerDiv
                id={id}
                minWidth={minWidth}
                onClick={dateSelectorPopUpOpen}
                aria-describedby={dateSelectorPopOverId}
                width={datePickerDivWidth}
                sameDayRdd={sameDayRdd}
                height={datePickerDivHeight}
                mbWidth={datePickerDivMbWidth}
                mbHeight={datePickerDivMbHeight}
                // sameDayRdd={sameDayRdd}
                // mobileHeight={mobileHeight}
                backgroundColor={datePickerBgColor}
                fontSize={fontSize}
                border={border}
                opacity={opacity}
                disabled={disabled}
                reportUsage={reportUsage}
                smbWidth={smbWidth}
                borderRadius={borderRadius}
            >
                <StyledDiv
                    left={left}
                    opacity={opacity === '0.5' ? '1' : opacity}
                    reportUsage={reportUsage}
                    textOpacity={textOpacity}
                    placeholderColor={
                        selectedDateFromDatePicker ? '#202124' : '#8f8f8f'
                    }
                >
                    {hasSelectedDate
                        ? getDisplayDate(selectedDateFromDatePicker)
                        : placeholder}
                </StyledDiv>
                <StyledSpan
                    iconPaddingTop={iconPaddingTop}
                    iconRight={iconRight}
                    mbIconRight={mbIconRight}
                    smbIconPaddingTop={smbIconPaddingTop}
                >
                    <DatePickerIcon
                        defaultImg={
                            datePickerCalendarIcon
                                ? datePickerCalendarIcon
                                : CalendarInactive
                        }
                        name="calendra-icon"
                        height={iconHeight}
                        smbIconheight={smbIconheight}
                    />
                </StyledSpan>
            </DatePickerDiv>

            <DatePopover
                id={dateSelectorPopOverId}
                open={isDateSelectorPopOverOpen}
                anchorEl={dateSelectorPopUpAnchorEl}
                onClose={dateSelectorPopUpClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'right',
                }}
                // ref={datePopoverRef}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
                style={{
                    zIndex: datePopOverZIndex ? datePopOverZIndex : 10000000,
                }}
                dismissable="true"
                top={dateSelectorPopUpAnchorEl ? topY : null}
                ref={calendarRef}
            >
                <DatePickerContainer
                    leftArrow={LeftArrow}
                    rightArrow={RightArrow}
                    disableLeftArrow={disablePrevMonth}
                    downArrowMonthDropDown={DownArrowMonthDropDown}
                    onClick={toggleNextButton}
                >
                    <Calendar
                        disabled={disabled}
                        inline
                        id={`${datepickerItem}`}
                        placeholder={`${placeholder}`}
                        value={hasSelectedDate ? selectedDateFromDatePicker : null}
                        onChange={(e) => {
                            onChange(e.value);
                            dateSelectorPopUpClose();
                        }}
                        showIcon={true}
                        showButtonBar={false}
                        monthNavigator={true}
                        yearNavigator={true}
                        yearRange={yearRange ? yearRange : '2010:2050'}
                        minDate={minDate}
                        disabledDates={enableMinDate}
                        disabledDays={disableWeekEnds}
                        maxDate={maxDate}
                        monthNavigatorTemplate={monthNavigatorTemplate}
                        yearNavigatorTemplate={yearNavigatorTemplate}
                        // headerTemplate={headerTemplate}
                    ></Calendar>
                </DatePickerContainer>
            </DatePopover>
        </>
    );
};

export default DatePicker;
